<script>
    import { onMount } from 'svelte';
    import { headerDisplayStore, loadingStore } from '../stores/General';
    import Table from '../components/table/Table.svelte';
    import { getList } from '../api';

    onMount(async () => {
        headerDisplayStore.SetTitle('IAB Categories');
        headerDisplayStore.SetBreadCrumbs([
            {
                key: 'iab',
                label: 'IAB Categories',
            },
        ]);

        loadData();
    });

    const columns = [
        { label: 'IAB Code', key: 'iab_category_id' },
        { label: 'Name', key: 'name' },
        { label: 'Example', key: 'example' },
    ];
    let filters = [{ label: '', key: 'search', filter: 'text' }];
    let pageSize = 10;
    let data = [];
    let count = 0;
    let page = 1;
    let sortBy = 'name';
    let sortOrder = 'ASC';
    let filter = {};

    function loadData() {
        const module_name = "iab"
        data = [];
        loadingStore.on(module_name)
        getList('iab/category', pageSize, page, sortBy, sortOrder, filter)
            .then((response) => {
                loadingStore.off(module_name)
                data = response.data;
                count = response.count;
            })
            .catch((error) => {
                loadingStore.off(module_name)
                headerDisplayStore.ShowError({
                    title: 'Server error',
                    subtitle: error?.message,
                });
            });
    }

    function onPageChange(event) {
        page = event.detail.page;
        pageSize = event.detail.pageSize;
        loadData();
    }

    function onSortChange(event) {
        sortBy = event.detail.sortBy;
        sortOrder = event.detail.sortOrder;
        loadData();
    }

    function onFilterChange(event) {
        filter = event.detail.filter;
        loadData();
    }
</script>
<div class="flex flex-col h-full">
    <div class="w-full sm:px-6">
    <div class="py-2 md:py-2">
        <div class="sm:flex items-center justify-end">
            <div>
            </div>
        </div>
    </div>
    <!-- <Table
        id="iab_categories"
        {columns}
        {filters}
        {data}
        {count}
        {pageSize}
        {page}
        {sortBy}
        {sortOrder}
        on:pageChange={onPageChange}
        on:sortChange={onSortChange}
        on:onFilterChange={onFilterChange}
    /> -->
</div>
</div>